import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { UserPreferencesService } from '@fi-shared/fi-shared-services/user-preferences.service';
import { DocumentService } from '@fi-app/document/document.service';
import { MediaBankService } from '@fi-app/media-bank/media-bank.service';
import { ChecklistService } from '@fi-app/checklist/checklist.service';
import { NewsFeedService } from '@fi-app/news-feed/news-feed.service';
import { CoreService, IMenuItem } from '@fi-app/core/core.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { UserService } from '@fi-app/user/user.service';

@Component({
    selector: 'fi-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-main-menu' },
    standalone: false,
})
export class MainMenuComponent implements OnInit, OnDestroy {
    menuItems$ = new BehaviorSubject<IMenuItem[]>([]);
    @Output('onChangeCompactMode') OnChangeCompactMode: EventEmitter<boolean> = new EventEmitter();

    get isDashboardVisible$() {
        return this.sessionService.isDashboardVisible$;
    }

    constructor(
        private sessionService: SessionService,
        private userPreferencesService: UserPreferencesService,
        private documentService: DocumentService,
        private mediaBankService: MediaBankService,
        private checklistService: ChecklistService,
        private newsFeedService: NewsFeedService,
        private coreService: CoreService,
        private userService: UserService,
        private userDataService: FiUserDataService,
    ) {}

    ngOnInit() {
        if (this.userPreferencesService.getIsCompactMode()) this.ChangeCompactMode(true);

        this.userDataService.onUserDataChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.updateMenuItems();
        });
        this.updateMenuItems();
    }

    private updateMenuItems() {
        if (this.userDataService.userData) {
            this.menuItems$.next(this.coreService.getMenuItems(this.userDataService.userData.ModuleAccessRights));
        }
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    ChangeCompactMode(isCompactMode) {
        const session = this.sessionService.getSession();
        session.Desktop.IsCompactMode = isCompactMode;
        this.OnChangeCompactMode.emit(session.Desktop.IsCompactMode);
        this.userPreferencesService.saveIsCompactMode(session.Desktop.IsCompactMode);
    }

    isCompactMode() {
        return this.sessionService.getSession().Desktop.IsCompactMode;
    }
}
